import { LevelGranulometry, LevelGranulometryInitialEntries } from '../../LevelGranulometry';
import { CaseGranulometry } from '../../../cases/CaseGranulometry';
import { isRoofingLevel } from './isRoofingLevel';

export const isUpperLevel = (
  caseGranulometry: CaseGranulometry,
  levelGranulometry: LevelGranulometryInitialEntries | LevelGranulometry
): boolean => levelGranulometry.level > 0 && !isRoofingLevel(caseGranulometry, levelGranulometry);
